import { render, staticRenderFns } from "./Biddinglist.vue?vue&type=template&id=0b4ca91c"
import script from "./Biddinglist.vue?vue&type=script&lang=js"
export * from "./Biddinglist.vue?vue&type=script&lang=js"
import style0 from "./Biddinglist.vue?vue&type=style&index=0&id=0b4ca91c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports